import axios from 'axios';

// Add request interceptor to log requests
axios.interceptors.request.use(
  (config) => {
    console.log(`[Axios Request] ${config.method?.toUpperCase()} ${config.url}`);
    return config;
  },
  (error) => {
    console.error('[Axios Request Error]', error);
    return Promise.reject(error);
  }
);

// Add response interceptor to log responses and errors
axios.interceptors.response.use(
  (response) => {
    console.log(`[Axios Response] ${response.config.method?.toUpperCase()} ${response.config.url} - Status: ${response.status}`);
    return response;
  },
  (error) => {
    if (error.response) {
      // Server responded with error status
      console.error(`[Axios Error] ${error.config?.method?.toUpperCase()} ${error.config?.url}`);
      console.error(`Status: ${error.response.status}`);
      console.error('Response data:', error.response.data);
      console.error('Full error:', error);
    } else if (error.request) {
      // Request was made but no response received
      console.error('[Axios Error] No response received:', error.request);
    } else {
      // Error in setting up the request
      console.error('[Axios Error] Request setup error:', error.message);
    }
    return Promise.reject(error);
  }
);

export default axios;
